module.exports = __webpack_public_path__ + "img/dark_left_item_bg.d547b7d3.png";